// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".create_kind[data-v-034c88d8]{padding:10px;background-color:var(--el-color-primary-light-9);margin-top:10px}.dialog-footer[data-v-034c88d8]{padding:20px 0;text-align:right}", ""]);
// Exports
module.exports = exports;
